export const features = Object.values(
  // prettier-ignore
  import.meta.glob("./features/*", {
    eager: true,
  }) as {
/* GENERATED */ "./features/credit.ts": typeof import("./features/credit.ts"),
/* GENERATED */ "./features/creditLines.ts": typeof import("./features/creditLines.ts"),
/* GENERATED */ "./features/experiments.ts": typeof import("./features/experiments.ts"),
/* GENERATED */ "./features/featureFlags.ts": typeof import("./features/featureFlags.ts"),
/* GENERATED */ "./features/onboarding.ts": typeof import("./features/onboarding.ts"),
/* GENERATED */ "./features/paymentMethods.ts": typeof import("./features/paymentMethods.ts"),
/* GENERATED */ "./features/promotions.ts": typeof import("./features/promotions.ts"),
/* GENERATED */ "./features/shopping.ts": typeof import("./features/shopping.ts"),
/* GENERATED */ "./features/subscriptions.ts": typeof import("./features/subscriptions.ts"),
/* GENERATED */ "./features/transactions.ts": typeof import("./features/transactions.ts"),
/* GENERATED */ "./features/user.ts": typeof import("./features/user.ts"),
/* GENERATED */ "./features/userProperties.ts": typeof import("./features/userProperties.ts")
}
);
